<template>
  <v-app>
    <!-- <v-app-bar
         app
         dark
         color="primary"
     >
       <div class="d-flex align-center">
         Тарифный калькулятор
       </div>
       <v-spacer></v-spacer>
     </v-app-bar>-->
    <IframeWidget v-if="isWidget" :isMobile="isMobile"></IframeWidget>
    <Calc v-if="!isWidget"  :isMobile="isMobile"></Calc>
  </v-app>
</template>


<script>
/* eslint-disable */
import IframeWidget from "./components/IframeWidget.vue";
import Calc from './components/Calc';

export default {
  name: 'App',
  components: {
    Calc,
    IframeWidget
  },
  data: () => ({
    isMobile: true,
    drawer:false,
    selectedItem:null,
  }),
  methods:{
    onResize () {
      this.isMobile = window.innerWidth < 1000;
    },
  },
  computed:{
    currentRouteName() {
      return this.$route.name;
    },
    isWidget(){
      if (this.currentRouteName=='widget'){
        return true;
      }
      return false;
    }
  },
  beforeDestroy () {
    if (typeof window === 'undefined') return
    window.removeEventListener('resize', this.onResize, { passive: true })
  },

  mounted() {
    this.onResize();
    window.addEventListener('resize', this.onResize, { passive: true })

  },
  beforeCreate() {
    document.title = "Тарифный калькулятор";
  }
};
</script>
